export function init_bootstrap($container) {
  $container.find('[data-toggle="popover"]').popover();
}
